// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ysiP","badges":"styles_badges__3xXo7"};